export default __webpack_public_path__ + "static/media/arizona_icon.1e6d7f07.png";